<template>
  <div class="header" id="header">
    <nav class="navbar navbar-expand-sm navbar-dark">
      <a class="navbar-brand" href="#"></a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        @click.stop="minUrl"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="logo">
          <router-link to="/">
            <img src="../assets/images/logo.png" :alt="this.seoName" />
            <!-- <img src="https://img.duoduiduo.com/gg/30/3/264e34ac1d0249619bfcc28e71db328b.png"
								:alt="this.seoName"> -->
          </router-link>
        </div>
        <ul
          class="navbar-nav col-12 col-sm-12 col-md-11 col-lg-10 col-xl-8 row text-center"
        >
          <li class="nav-item col">
            <router-link class="nav-link" to="/" exact>首页</router-link>
          </li>
          <li class="nav-item col">
            <router-link class="nav-link" to="/matter">解决方案</router-link>
          </li>
          <li class="nav-item col">
            <router-link class="nav-link" to="/module">合作模式</router-link>
          </li>

          <!-- <li class="nav-item col">
						<router-link class="nav-link" to="/neighbourhood">数字家庭</router-link>
					</li>
					<li class="nav-item col">
						<router-link class="nav-link" to="/family">数字康养</router-link>
					</li> -->
          <li class="nav-item col">
            <router-link class="nav-link" to="/trade">合作案例</router-link>
          </li>
          <li class="nav-item col">
            <router-link class="nav-link" to="/about/synopsis?name=why"
              >集团介绍</router-link
            >
          </li>
          <li class="nav-item col">
            <router-link class="nav-link" to="/news">新闻资讯</router-link>
          </li>
          <li class="nav-item col">
            <a
              class="nav-link"
              href="https://supply.duoduiduo.com/topicPage?health_appId=862202203150004&health_shopid=59&health_is_warehouse=public"
              >药品目录</a
            >
          </li>
          <!-- <li class="nav-item col dropdown">
						<router-link :class="['nav-link','dropdown-toggle',isAbout?'on':'']" data-toggle="dropdown"
							to="#">关于我们</router-link>
						<div class="dropdown-menu">
							<router-link class="dropdown-item" to="/about/synopsis">集团介绍</router-link>
							<router-link class="dropdown-item" to="/about/foundingTeam">组织架构</router-link>
							<router-link class="dropdown-item" to="/about/successCase">案例分享</router-link>
							<router-link class="dropdown-item" to="/about/videoGroup">视频荟萃</router-link>
						</div>
					</li> -->
        </ul>
      </div>
      <div
        v-if="minUrlShow"
        class="min_url_wrap"
        @click.stop="minUrlShow = false"
      >
        <li class="nav-item col">
          <router-link class="nav-link" to="/" exact>首页</router-link>
        </li>
        <li class="nav-item col">
          <router-link class="nav-link" to="/matter">解决方案</router-link>
        </li>
        <li class="nav-item col">
          <router-link class="nav-link" to="/module">合作模式</router-link>
        </li>
        <li class="nav-item col">
          <router-link class="nav-link" to="/trade">合作案例</router-link>
        </li>
        <li class="nav-item col">
          <router-link class="nav-link" to="/about/synopsis?name=why"
            >集团介绍</router-link
          >
        </li>
        <li class="nav-item col">
          <router-link class="nav-link" to="/news">新闻资讯</router-link>
        </li>
        <li class="nav-item col">
          <a
            class="nav-link"
            href="https://supply.duoduiduo.com/topicPage?health_appId=862202203150004&health_shopid=59&health_is_warehouse=public"
            >药品目录</a
          >
        </li>
        <!-- <li class="nav-item col dropdown" @click.stop>
					<router-link :class="['nav-link','dropdown-toggle',isAbout?'on':'']" data-toggle="dropdown"
						to="/about/synopsis">关于我们</router-link>
					<div class="dropdown-menu">
						<router-link class="dropdown-item" to="/about/synopsis">集团介绍</router-link>
						<router-link class="dropdown-item" to="/about/foundingTeam">团队力量</router-link>
						<router-link class="dropdown-item" to="/about/successCase">案例分享</router-link>
						<router-link class="dropdown-item" to="/about/videoGroup">视频荟萃</router-link>
					</div>
				</li> -->
      </div>
    </nav>

    <div class="banner">
      <div
        id="banner"
        class="carousel slide"
        data-ride="carousel"
        v-if="banner.length > 0"
      >
        <!-- 指示符 -->
        <ul class="carousel-indicators">
          <li
            data-target="#banner"
            data-slide-to="index"
            :class="[index == 0 ? 'active' : '']"
            v-for="(item, index) in banner"
            :key="index"
          ></li>
        </ul>

        <!-- 轮播图片 -->
        <div class="carousel-inner">
          <div
            :class="['carousel-item', index == 0 ? 'active' : '']"
            v-for="(item, index) in banner"
            :key="index"
          >
            <img
              :src="item.content_value"
              alt="多对多物联网平台"
              @click="toUrl(item.url)"
              width="100%"
            />
          </div>
        </div>

        <!-- 左右切换按钮 -->
        <a class="carousel-control-prev" href="#banner" data-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </a>
        <a class="carousel-control-next" href="#banner" data-slide="next">
          <span class="carousel-control-next-icon"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "topNav",
  data() {
    return {
      banner: [],
      showTimeout: 0,
      activeIndex: "",
      bannerHeight: document.body.clientWidth / 2.8,
      isAbout: false, //当前路由是否为关于我们子页面
      minUrlShow: false,
    };
  },
  mounted() {
    //获取轮播数据
    this.getBanner();
    const that = this;
    let path = this.$route.path;
    this.activeIndex = path;
    //设置顶部轮播高度
    window.onresize = function () {
      let width = document.body.clientWidth;
      that.bannerHeight = width / 2.8;
    };
    this.bannerHeight = document.body.clientWidth / 2.8;
  },
  watch: {
    $route(to, from) {
      this.getRoute();
    },
  },
  methods: {
    //检测当前页面是否为关于我们子页面
    getRoute() {
      let pathUrl = this.$route.path;
      if (
        pathUrl == "/about/videoGroup" ||
        pathUrl == "/about/successCase" ||
        pathUrl == "/about/synopsis"
      ) {
        this.isAbout = true;
      } else {
        this.isAbout = false;
      }
    },
    //导航跳转具体页
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.$router.push({
        path: key,
      });
    },
    //获取首页轮播
    getBanner() {
      let token = window.localStorage.getItem("token");
      if (token) {
        this.getBannerData();
      } else {
        this.getToken();
      }
    },
    //获取轮播
    getBannerData() {
      this.sendHttp({
        url: this.baseUrl + "/index/getplate",
        method: "post",
        data: {
          alias: "banner",
          webpage: "www",
        },
      }).then((res) => {
        if (res.code == "0") {
          this.banner = res.data;
          //console.log(res);
        }
      });
    },
    //获取token
    getToken() {
      this.sendHttp({
        method: "post",
        url: `${this.accountUrl}/api/accesstoken`,
        data: {},
      }).then((res) => {
        if (res.code == "0") {
          // 把获取到的存到本地缓存
          window.localStorage.setItem("token", res.data.token);
          //获取轮播
          this.getBannerData();
        }
      });
    },
    //轮播跳转
    toUrl(url) {
      window.location.href = url;
    },
    //搜索
    search(e) {
      let keyboard = e.target.value;
      window.sessionStorage.setItem("keyboard", keyboard);
      let key = window.sessionStorage.getItem("keyboard");
      this.$router.push({
        path: "/news",
        query: {
          keyboard: key,
        },
      });
    },

    // 小尺寸路由跳转，自适应的那个报错，没找到原因
    minUrl() {
      this.minUrlShow = !this.minUrlShow;
    },

    // 供父组件调用
    fatherMinUrl() {
      if (this.minUrlShow) {
        this.minUrlShow = false;
      }
    },
  },
};

$(function () {
  $("nav ul li")
    .click(function () {
      hideNav();
    })
    .not($("nav ul .dropdown"));

  $(".dropdown-menu .dropdown-item").click(function () {
    hideNav();
  });

  function hideNav() {
    $(".navbar-collapse").removeClass("show");
  }

  $("nav ul .dropdown").click(function () {
    $(".navbar-collapse").addClass("show");
  });
});
</script>

<style scoped lang="less">
nav {
  ul {
    padding: 0;
  }
}

.dropdown-item.active,
.dropdown-item:active {
  background: #00a0ea;
}

.dropdown-menu {
  width: 100%;
  min-width: 0;
  text-indent: 5px;
  margin: 0;
  padding: 0;

  .dropdown-item {
    padding: 0.25rem 0.2rem;
    border-bottom: 1px solid #ececec;

    &:last-child {
      border: none;
    }
  }
}

.dropdown-menu .on {
  background: #00a0ea;
  color: #ffffff;
}

.header {
  .navbar-brand {
    margin-right: 10px;
  }

  .logo {
    width: 200px;
    margin: 5px 80px;
    a {
      display: block;
      // width: 20%;
      padding: 0;
      img {
        margin: 15px 0;
        width: 90%;
      }
    }
  }
  .banner {
    .carousel-control-prev-icon {
      background: url("~img/home/left.png") center no-repeat;
    }

    .carousel-control-next-icon {
      background: url("~img/home/right.png") center no-repeat;
    }

    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 6px;
      width: 30%;
      height: 22%;
      background-size: 100%;

      @media (max-width: 768px) {
        display: none;
      }
    }

    .carousel-indicators {
      bottom: 5%;

      li {
        width: 3%;
        padding: 1px 0;

        @media (max-width: 576px) {
          padding: 0;
        }

        border: none;
        border-radius: 6px;

        &.active {
          width: 4%;
        }
      }
    }
  }
}
</style>

<style scoped lang="less">
nav {
  background: #ffffff;

  @media (max-width: 700px) {
    font-size: 14px;

    .dropdown-menu a {
      font-size: 14px;
    }
  }
}

.navbar {
  padding: 0;
  position: relative;
  .navbar-nav {
    margin: 0 auto;

    li {
      padding: 0;

      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.navbar-dark .navbar-nav .nav-link {
  color: #000000;
  &:hover {
    color: #000000;
  }
  @media (max-width: 625px) {
    padding: 5px 0;
  }

  &.on {
    background: #fff;
    color: #ee7b1d;
  }
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
}

.min_url_wrap {
  width: 150px;
  background-color: #fff;
  position: absolute;
  top: 40px;
  right: 0;
  z-index: 999;
  li {
    list-style: none;
    // a{
    // 	color: #ee8835;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topNav.vue